import Moment from 'moment';

import { PlannerItemModelTypeEnum } from '../enums/plannerItemModelType.enum';

import { outOfDate } from './outOfCurrentDate';

export const addItemToPlannerList = ({
  plannerList,
  item,
  topPaginationDate,
  bottomPaginationDate,
  plannerGeneralMaxMinDate,
}: {
  plannerList: any;
  item: any;
  topPaginationDate: string;
  bottomPaginationDate: string;
  plannerGeneralMaxMinDate: any;
}) => {
  const outOfMinDate = outOfDate(item.started_at || '', plannerGeneralMaxMinDate.started_at || '');

  const outOMaxDate = outOfDate(plannerGeneralMaxMinDate.finished_at || '', item.finished_at || '');
  const outOfTopPaginationDate = outOfDate(item.started_at || '', topPaginationDate || '');
  const outOfBottomPaginationDate = outOfDate(bottomPaginationDate || '', item.finished_at || '');
  const startDate =
    outOfMinDate && topPaginationDate === Moment(plannerGeneralMaxMinDate.started_at).format('YYYY-MM-DD')
      ? Moment.utc(item.started_at, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD')
      : outOfTopPaginationDate
        ? topPaginationDate
        : Moment.utc(item.started_at, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD');

  const finishDate =
    outOMaxDate && bottomPaginationDate === Moment(plannerGeneralMaxMinDate.finished_at).format('YYYY-MM-DD')
      ? Moment.utc(item.finished_at, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD')
      : outOfBottomPaginationDate
        ? bottomPaginationDate
        : Moment.utc(item.finished_at, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD');

  const dayDiff = Moment(finishDate).diff(Moment(startDate), 'days');
  const daysArr: string[] = [];
  let newPlannerList = [...plannerList];

  for (let i = 0; i <= dayDiff; i++) {
    daysArr.push(Moment(startDate).add(i, 'days').format('YYYY-MM-DD'));
  }

  daysArr.forEach((day: string) => {
    const dayIndex = newPlannerList.findIndex(
      (dayItem) => Moment(dayItem.date).diff(Moment(day), 'days') === 0,
    );

    if (dayIndex !== -1) {
      newPlannerList = newPlannerList.map((dayItem: any) => {
        if (Moment(dayItem.date).diff(Moment(day), 'days') === 0) {
          return {
            ...dayItem,
            eventCount:
              item.model_type === PlannerItemModelTypeEnum.event ||
              item.model_type === PlannerItemModelTypeEnum.meet ||
              item.model_type === PlannerItemModelTypeEnum.appointment
                ? dayItem.eventCount + 1
                : dayItem.eventCount,
            taskCount:
              item.model_type === PlannerItemModelTypeEnum.task ? dayItem.taskCount + 1 : dayItem.taskCount,
            reminderCount:
              item.model_type === PlannerItemModelTypeEnum.reminder
                ? dayItem.reminderCount + 1
                : dayItem.reminderCount,
            items: [...dayItem.items, item]
              .sort((a: any, b: any) => {
                const dateA = new Date(Moment(a.started_at).format()).getTime();
                const dateB = new Date(Moment(b.started_at).format()).getTime();
                const dateDiff = dateA - dateB;
                if (dateDiff !== 0) {
                  return dateDiff;
                }
                const order = {
                  [PlannerItemModelTypeEnum.reminder]: 1,
                  [PlannerItemModelTypeEnum.meet]: 2,
                  [PlannerItemModelTypeEnum.task]: 3,
                  [PlannerItemModelTypeEnum.event]: 4,
                  [PlannerItemModelTypeEnum.appointment]: 5,
                  [PlannerItemModelTypeEnum.payment]: 6,
                  [PlannerItemModelTypeEnum.note]: 7,
                  [PlannerItemModelTypeEnum.todo]: 8,
                };
                return (
                  (order[a.model_type as PlannerItemModelTypeEnum] || 9) -
                  (order[b.model_type as PlannerItemModelTypeEnum] || 9)
                );
              })
              .sort((a: any, b: any) => {
                if (b?.is_all_day === true) {
                  return 1;
                }
                if (a?.is_all_day === true) {
                  return -1;
                }
                return 0;
              }),
          };
        }
        return dayItem;
      });
    } else {
      newPlannerList.push({
        eventCount:
          item.model_type === PlannerItemModelTypeEnum.event ||
          item.model_type === PlannerItemModelTypeEnum.meet ||
          item.model_type === PlannerItemModelTypeEnum.appointment
            ? 1
            : 0,
        taskCount: item.model_type === PlannerItemModelTypeEnum.task ? 1 : 0,
        reminderCount: item.model_type === PlannerItemModelTypeEnum.reminder ? 1 : 0,
        paymentCount: 0,
        date: Moment(day).format('MMMM DD, YYYY'),
        items: [item],
      });
    }
  });

  return newPlannerList.sort((a, b) => {
    return Moment(a.date).diff(Moment(b.date), 'minute');
  });
};
